import type { ViewQueryField, ViewQueryList, ViewQueryNode, ViewQueryNodeReadJoinOnId } from '@salescore/core'
import { isUndefined } from 'effect/Predicate'
import { fail, type Result, succeed } from 'effect/Result'

import { getNodePure } from '../../../state/nodeUtility'

export type GetParentReferenceFieldError =
  | `parentNode not found`
  | `parentNodeColumnName undefined`
  | `カスタムSQLによるJOINを定義している場合、このアクションは実行できません`
  | `parentNodeColumnName must not be id`

// 引数で渡したnodeの親ノードについて、親ノードに参照フィールドがある場合にそのフィールドを取得する関数
// joinOn.type が sql の場合や、parentNodeColumnName が id の場合はエラーを返す
export function getParentReferenceField(
  query: Pick<ViewQueryList, 'tree' | 'fields'>,
  node: Pick<ViewQueryNode, 'path' | 'read'>,
): Result<
  {
    parentReferenceField: ViewQueryField | undefined
    join: ViewQueryNode['read']['join'] & { joinOn: ViewQueryNodeReadJoinOnId }
    parentNode: ViewQueryNode
  },
  GetParentReferenceFieldError
> {
  const parentNode = getNodePure(query.tree, node.path.slice(0, -1))
  if (parentNode === undefined) {
    return fail(`parentNode not found`)
  }

  const { join } = node.read
  if (isUndefined(join)) {
    return fail(`parentNodeColumnName undefined`)
  }
  const { joinOn } = join
  if (joinOn.type === 'sql') {
    // i18n: エラー系は一旦保留
    return fail(`カスタムSQLによるJOINを定義している場合、このアクションは実行できません`)
  }
  if (joinOn.parentNodeColumnName === 'id') {
    return fail(`parentNodeColumnName must not be id`)
  }
  const parentReferenceField = query.fields.find((field) => {
    const [x] = field.meta.dependedPropertyNamesWithStreamName
    if (x === undefined) {
      return false
    }
    return x.streamName === joinOn.meta.parentNodeStreamName && x.propertyName === joinOn.meta.parentNodePropertyName
  })

  return succeed({
    parentReferenceField,
    join: { ...join, joinOn }, // 型を絞るためにやっている
    parentNode,
  })
}
